let accessToken = null

export const setAccessToken = (idToken) => {
  accessToken = idToken
}

export const getAccessToken = () => accessToken
